import assert from 'assert-ts';
import type {LinkedLiterary} from 'schemaDefinition/types';
import {isVerifiedLinkedCollection} from 'schemaDefinition/functions/isVerifiedLinkedCollection';
import type {BulkUpdateCreate} from '../types';
import type {Schemas} from '../dto.generated';

export const mapToBulkUpdateActionDto = (
  dto: Pick<
    BulkUpdateCreate,
    'bulkUpdateAction' | 'currentValues' | 'newValues' | 'addToFirstPosition'
  >,
): Schemas.BulkUpdateWorkRequest['action'] => {
  switch (dto.bulkUpdateAction) {
    case 'ADD':
      return {
        action: 'ADD',
        addValues: mapToDtoValues(
          assert(dto.newValues, 'ADD: newValue expected'),
        ),
        addToFirstPosition: dto.addToFirstPosition,
      };
    case 'REMOVE':
      return {
        action: 'REMOVE',
        removeValues: mapToDtoValues(
          assert(dto.currentValues, 'REMOVE: currentValue expected'),
        ),
      };
    case 'REPLACE': {
      const val = assert(
        assert(dto.currentValues, 'REPLACE: currentValue expected')[0],
        'REPLACE: currentValue[0] expected',
      );
      assert(typeof val === 'string', 'REPLACE: Expected string', {val});

      return {
        action: 'REPLACE',
        currentValue: val,
        updatedValues: mapToDtoValues(
          assert(dto.newValues, 'REPLACE: newValue expected'),
        ),
        addToFirstPosition: dto.addToFirstPosition,
      };
    }
  }

  assert(false, 'mapBulkUpdateActionDto: Expected action', dto);
};

const mapToDtoValues = (dto: string[] | LinkedLiterary[]): string[] => {
  const links = dto.filter(isVerifiedLinkedCollection);
  if (links.length > 0) {
    return links.map(l => l.link.entityId);
  }

  return dto as string[];
};
